module.exports = __webpack_public_path__ + "static/media/user-dropdown-client-mode.534a8dc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/user-dropdown-client-mode.svg
// module id = 1586
// module chunks = 0